import React from 'react';
import CreatorIframe from '@/components/CreatorIframe';
import { getEnv } from '@/utils';

const domainMap = {
    test: 'http://creatorplatform.waimai.test.sankuai.com',
    stage: 'https://creatorplatform.waimai.st.sankuai.com',
    prod: 'https://creatorplatform.waimai.meituan.com',
};
const domain = domainMap[getEnv()];
const url = `${domain}/platform/fe/#/third/platform/list/video`;

const VideoCreate: React.FC = () => <CreatorIframe url={url} />;

export default VideoCreate;
